import { isBindingContextLoaded } from "../../../common/module-guard";

import { DefaultCanvasGlyphRender } from "./glyph-render";

import { GlyphRender, GraphicRender } from "./symbol";

const loadedGlyphModuleContexts = new WeakSet;

export function bindGlyphRenderModule({bind: bind}) {
    isBindingContextLoaded(loadedGlyphModuleContexts, bind) || (bind(DefaultCanvasGlyphRender).toDynamicValue((() => new DefaultCanvasGlyphRender)).inSingletonScope(), 
    bind(GlyphRender).toService(DefaultCanvasGlyphRender), bind(GraphicRender).toService(GlyphRender));
}

export const glyphModule = bindGlyphRenderModule;
//# sourceMappingURL=glyph-module.js.map
